import { connectHook } from 'app/common/components/connect-hook';
import DropdownWidget from 'app/common/components/widgets/dropdown';
import { useToolArgumentPicker } from './tool-editor-argument-picker-hook.js';

export default connectHook(DropdownWidget, useToolArgumentPicker);
